import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["source", "status"]

  async copy() {
    const text = this.sourceTarget.textContent

    try {
      if (navigator.clipboard) {
        await this.writeWithTimeout(text)
      } else {
        this.copyWithFallback(text)
      }

      this.statusTarget.textContent = "コピーしました"
    } catch (_error) {
      try {
        this.copyWithFallback(text)
        this.statusTarget.textContent = "コピーしました"
      } catch (_fallbackError) {
        this.statusTarget.textContent = "コピーできませんでした"
      }
    }
  }

  writeWithTimeout(text) {
    return Promise.race([
      navigator.clipboard.writeText(text),
      new Promise((_, reject) => {
        setTimeout(() => reject(new Error("Clipboard write timed out")), 500)
      })
    ])
  }

  copyWithFallback(text) {
    const textarea = document.createElement("textarea")
    textarea.value = text
    textarea.setAttribute("readonly", "")
    textarea.style.position = "absolute"
    textarea.style.left = "-9999px"
    document.body.appendChild(textarea)
    textarea.select()
    document.execCommand("copy")
    document.body.removeChild(textarea)
  }
}
